module.exports = __webpack_public_path__ + "jp.svg?b5b509c87244a9ff54e87d54f97d64bd";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/jp.svg
// module id = 1437
// module chunks = 0